export default __webpack_public_path__ + "static/media/blocks-and-car.825e3a70.svg";